import { Card, Col, Row } from "react-bootstrap";
import { TbCoins, TbTruckDelivery } from "react-icons/tb";
import DetailedList from "../../shared/DetailedList";
import { FaSwimmingPool } from "react-icons/fa";
import { useState } from "react";
import PdfModal from "../../shared/PdfModal";

const DocumentsCard = ({abrechnungen, vorschreibungen, poolrechnungen}) => {

    const [showPDFViewModal, setShowPDFViewModal] = useState(false);
    const [base64PDF, setBase64PDF] = useState("");
    const iconsSize = 30;

    const viewPDFHandler = (b64) => {
        setBase64PDF(b64);
        setShowPDFViewModal(true);
    }

    return (
        <>
            <Card className="radius-20 shadow-lg">
                <Card.Body>
                    <h5>Dokumente</h5>
                    <Row className="mt-3">
                        <Col>
                            <div className="mb-5">
                                <div className="documents-header bg-primary">
                                    <TbTruckDelivery size={iconsSize} /> Energielieferant
                                </div>
                                <DetailedList key="abrList" data={abrechnungen} type="abrechnung" pdfReader={viewPDFHandler} />
                            </div>
                            <div className="mb-5">
                                <div className="documents-header bg-warning">
                                    <TbCoins size={iconsSize} /> Vorschreibungen
                                </div>
                                <DetailedList key="vorList" data={vorschreibungen} type="vorschreibung" pdfReader={viewPDFHandler} />
                            </div>
                            <div className="mb-5">
                                <div className="documents-header bg-energo">
                                    <FaSwimmingPool size={iconsSize} /> ENERGO
                                </div>
                                <DetailedList key="poolList" data={poolrechnungen} type="poolrechnung" pdfReader={viewPDFHandler} />
                            </div>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <PdfModal show={showPDFViewModal} setShow={setShowPDFViewModal} file={base64PDF} />
        </>
    )
}
export default DocumentsCard;